import DocumentResultController from '@/controllers/DocumentResultController';
import DocumentsController from '@/controllers/DocumentsController';
import FragmentSelectionController from '@/controllers/FragmentSelectionController';
import HomeController from '@/controllers/HomeController';
import LabelsController from '@/controllers/LabelsController';
import LabelTypesController from '@/controllers/LabelTypesController';
import PublishersController from '@/controllers/PublishersController';
import SerfQueueController from '@/controllers/SerfQueueController';
import { RouteNames } from '@/router/route-names';
import SummarySelectionView from '@/views/SummarySelectionView.vue';
import AssistantView from '@/views/AssistantView.vue';
import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: HomeController,
  },
  {
    path: '/queue',
    name: 'Job Queue',
    component: SerfQueueController,
  },
  {
    path: '/queue/duplicate/:duplicateJobId',
    name: RouteNames.DuplicateJob,
    component: SerfQueueController,
    props: parseNumberProps('duplicateJobId'),
  },
  {
    path: '/document',
    name: 'Documents',
    component: DocumentsController,
  },
  {
    path: '/document/:documentId/ingest/:ingestId?/:scrollToFragmentId?',
    name: RouteNames.DocumentResult,
    component: DocumentResultController,
    props: parseNumberProps('documentId', 'ingestId', 'scrollToFragmentId'),
  },
  {
    path: '/selection',
    name: RouteNames.Selection,
    component: FragmentSelectionController,
    props: parseNumberProps('documentId'),
  },
  {
    path: '/summary',
    name: RouteNames.Summaries,
    component: SummarySelectionView,
    props: parseNumberProps('documentId'),
  },
  {
    path: '/selection/query/:queryId',
    name: RouteNames.SelectionQuery,
    component: FragmentSelectionController,
    props: parseNumberProps('queryId'),
  },
  {
    path: '/assistant',
    name: RouteNames.Assistant,
    component: AssistantView,
  },
  {
    path: '/publisher',
    name: 'Publisher',
    component: PublishersController,
  },
  {
    path: '/label',
    name: 'Labels',
    component: LabelsController,
  },
  {
    path: '/label-type',
    name: 'Label Types',
    component: LabelTypesController,
  },
];

function parseNumberProps(...props: string[]): (route: Route) => {} {
  return (route: Route) => {
    const parsed = props.reduce((acc, k) => {
      const p = route.params[k];
      const q = route.query[k];
      if (!!p && !!q) {
        // eslint-disable-next-line no-console
        console.warn(`Property ${k} supplied as both path and query param`);
      }
      return { ...acc, [k]: toNumber(p ?? q) };
    }, {});
    return { ...route.params, ...parsed };
  };
}
function toNumber(s?: string): number | undefined {
  if (s) {
    const v = Number.parseInt(s, 10);
    if (!Number.isNaN(v)) {
      return v;
    }
  }
  return undefined;
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
